"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignPackageRequestToJSON = exports.AssignPackageRequestFromJSONTyped = exports.AssignPackageRequestFromJSON = exports.instanceOfAssignPackageRequest = exports.AssignPackageRequestInvoiceOptionEnum = void 0;
const runtime_1 = require("../runtime");
const AssignPackageRequestCurriculumAssignmentsInner_1 = require("./AssignPackageRequestCurriculumAssignmentsInner");
const AssignPackageRequestMembersSettingsInner_1 = require("./AssignPackageRequestMembersSettingsInner");
const PackageInstanceOrganizationSettings_1 = require("./PackageInstanceOrganizationSettings");
/**
* @export
* @enum {string}
*/
var AssignPackageRequestInvoiceOptionEnum;
(function (AssignPackageRequestInvoiceOptionEnum) {
    AssignPackageRequestInvoiceOptionEnum["None"] = "none";
    AssignPackageRequestInvoiceOptionEnum["Draft"] = "draft";
    AssignPackageRequestInvoiceOptionEnum["SharedViaEmail"] = "shared-via-email";
    AssignPackageRequestInvoiceOptionEnum["Scheduled"] = "scheduled";
    AssignPackageRequestInvoiceOptionEnum["Charge"] = "charge";
})(AssignPackageRequestInvoiceOptionEnum || (exports.AssignPackageRequestInvoiceOptionEnum = AssignPackageRequestInvoiceOptionEnum = {}));
/**
 * Check if a given object implements the AssignPackageRequest interface.
 */
function instanceOfAssignPackageRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "packageId" in value;
    return isInstance;
}
exports.instanceOfAssignPackageRequest = instanceOfAssignPackageRequest;
function AssignPackageRequestFromJSON(json) {
    return AssignPackageRequestFromJSONTyped(json, false);
}
exports.AssignPackageRequestFromJSON = AssignPackageRequestFromJSON;
function AssignPackageRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'packageId': json['packageId'],
        'isAssignedByCoach': !(0, runtime_1.exists)(json, 'isAssignedByCoach') ? undefined : json['isAssignedByCoach'],
        'startDate': !(0, runtime_1.exists)(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'expiration': !(0, runtime_1.exists)(json, 'expiration') ? undefined : (json['expiration'] === null ? null : new Date(json['expiration'])),
        'quantity': !(0, runtime_1.exists)(json, 'quantity') ? undefined : json['quantity'],
        'customSubscriptionId': !(0, runtime_1.exists)(json, 'customSubscriptionId') ? undefined : json['customSubscriptionId'],
        'locked': !(0, runtime_1.exists)(json, 'locked') ? undefined : json['locked'],
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
        'paymentOptionIndex': !(0, runtime_1.exists)(json, 'paymentOptionIndex') ? undefined : json['paymentOptionIndex'],
        'invoiceOption': !(0, runtime_1.exists)(json, 'invoiceOption') ? undefined : json['invoiceOption'],
        'participants': !(0, runtime_1.exists)(json, 'participants') ? undefined : json['participants'],
        'supervisors': !(0, runtime_1.exists)(json, 'supervisors') ? undefined : json['supervisors'],
        'organizationSettings': !(0, runtime_1.exists)(json, 'organizationSettings') ? undefined : (0, PackageInstanceOrganizationSettings_1.PackageInstanceOrganizationSettingsFromJSON)(json['organizationSettings']),
        'membersSettings': !(0, runtime_1.exists)(json, 'membersSettings') ? undefined : (json['membersSettings'].map(AssignPackageRequestMembersSettingsInner_1.AssignPackageRequestMembersSettingsInnerFromJSON)),
        'curriculumAssignments': !(0, runtime_1.exists)(json, 'curriculumAssignments') ? undefined : (json['curriculumAssignments'].map(AssignPackageRequestCurriculumAssignmentsInner_1.AssignPackageRequestCurriculumAssignmentsInnerFromJSON)),
        'calculateRollover': !(0, runtime_1.exists)(json, 'calculateRollover') ? undefined : json['calculateRollover'],
        'priceId': !(0, runtime_1.exists)(json, 'priceId') ? undefined : json['priceId'],
    };
}
exports.AssignPackageRequestFromJSONTyped = AssignPackageRequestFromJSONTyped;
function AssignPackageRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'packageId': value.packageId,
        'isAssignedByCoach': value.isAssignedByCoach,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString().substr(0, 10)),
        'expiration': value.expiration === undefined ? undefined : (value.expiration === null ? null : value.expiration.toISOString().substr(0, 10)),
        'quantity': value.quantity,
        'customSubscriptionId': value.customSubscriptionId,
        'locked': value.locked,
        'title': value.title,
        'icon': value.icon,
        'paymentOptionIndex': value.paymentOptionIndex,
        'invoiceOption': value.invoiceOption,
        'participants': value.participants,
        'supervisors': value.supervisors,
        'organizationSettings': (0, PackageInstanceOrganizationSettings_1.PackageInstanceOrganizationSettingsToJSON)(value.organizationSettings),
        'membersSettings': value.membersSettings === undefined ? undefined : (value.membersSettings.map(AssignPackageRequestMembersSettingsInner_1.AssignPackageRequestMembersSettingsInnerToJSON)),
        'curriculumAssignments': value.curriculumAssignments === undefined ? undefined : (value.curriculumAssignments.map(AssignPackageRequestCurriculumAssignmentsInner_1.AssignPackageRequestCurriculumAssignmentsInnerToJSON)),
        'calculateRollover': value.calculateRollover,
        'priceId': value.priceId,
    };
}
exports.AssignPackageRequestToJSON = AssignPackageRequestToJSON;
//# sourceMappingURL=AssignPackageRequest.js.map